import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useConvertToPendingPal } from "../../../store/useConvertToPendingPal";
import { enumToMap } from "../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import {
    EmergencyPreparednessInfo,
    EmergencyPreparednessInfoEnum,
    EmergencyPriorities
} from "../../../../../../enums/enums";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import CommentInput from "../../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";

export default defineComponent({
    components: {
        FormSection,
        CommentInput
    },

    computed: {
        ...mapState(useConvertToPendingPal, {
            accountId: "accountId",
            patientId: "patientId",
            patient: "patientDetails",
            application: "application"
        })
    },

    data(vm) {
        return {
            isHisSection: true,
            emergencyPrioritiesEnum: EmergencyPriorities,
            emergencyPreparednessInformationEnum: EmergencyPreparednessInfo,
            showAdditionalInfo: false,
            evacuationPrimaryPhoneNumber: {
                number: "",
                extension: "",
                type: 1,
                country: null,
                isPrimary: true
            },
            evacuationAlternatePhoneNumber: {
                number: "",
                extension: "",
                type: 1,
                country: null,
                isPrimary: true
            },
            emergencyPrioritiesInfo: [
                "",
                "Patients who require uninterrupted services because they are the most vulnerable. In the case of a disaster or emergency, every possible effort must be made to see this patient. The patient's condition is unpredictable and deteriorating.",
                "The patient's symptoms are managed at this time and services may be postponed and replaced with telephone contact without detriment to the patient.",
                "The patient's symptoms are managed at this time and they have access to informal support to provide care. The patient can safely miss a scheduled visit if basic care is provided by family members, other informal support, or by the patient themselves."
            ],
            enumToMap
        };
    },

    created() {
        this.emergencyPrioritiesEnum.enumWithDescriptions.delete("MissingTriageLevel");
    },

    methods: {
        emergencyPrepInfoChanged(value: number) {
            const index = this.patient.emergencyPreparedness.emergencyPreparednessInformationValues?.indexOf(value);
            if (index !== -1) {
                this.patient.emergencyPreparedness.emergencyPreparednessInformationValues.splice(index, 1);
            } else {
                this.patient.emergencyPreparedness.emergencyPreparednessInformationValues.push(value);
            }
            if (value === EmergencyPreparednessInfoEnum.AdditionalEmergencyPreparedness) {
                this.showAdditionalInfo = !this.showAdditionalInfo;
            }
        },
        selectChange(newValue: number) {
            this.patient.emergencyPreparedness.emergencyPreparednessPriority = newValue;
        },
        resultUpdatedAppended(value: string) {
            this.patient.emergencyPreparedness.additionalEmergencyInformation += value;
        },
        resultUpdated(value: string) {
            this.patient.emergencyPreparedness.additionalEmergencyInformation = value;
        }
    }
});
